import Modal from 'particles/Modal'
import styled from 'particles/themes/styled'
import React, { useState } from 'react'
import ObjectiveDetails from './ObjectiveDetails'
import ObjectiveCard, { ObjectiveCardProps } from './ObjectiveCard'
import { ObjectiveType } from 'state/campaignTemplates'
import { TFunction } from 'i18next'
import { useNewTranslation } from 'hooks'

const getObjectiveOptions = (t: TFunction): ObjectiveCardProps[] => [
    {
        title: t('campaign.objectiveModal.awarenessButton.title'),
        type: 'awareness',
        description: t('campaign.objectiveModal.awarenessButton.subTitle'),
    },
    {
        title: t('campaign.objectiveModal.trafficButton.title'),
        type: 'traffic',
        description: t('campaign.objectiveModal.trafficButton.subTitle'),
    },
    {
        title: t('campaign.objectiveModal.credibilityButton.title'),
        type: 'credibility',
        description: t('campaign.objectiveModal.credibilityButton.subTitle'),
    },
    {
        title: t('campaign.objectiveModal.appPromotionButton.title'),
        type: 'appPromotion',
        description: t('campaign.objectiveModal.appPromotionButton.subTitle'),
    },
    {
        title: t('campaign.objectiveModal.contentButton.title'),
        type: 'content',
        description: t('campaign.objectiveModal.contentButton.subTitle'),
    },
]

interface ObjectiveFormProps {
    onClick?: (objective: ObjectiveType) => void
    onClose: () => void
}

const ObjectiveForm: React.FC<ObjectiveFormProps> = ({ onClick, onClose }) => {
    const [t] = useNewTranslation()
    // define how to handle select later in flow implementation ticket
    const [selectedIdx, setSelectedIdx] = useState(0)
    const options = getObjectiveOptions(t)
    return (
        <Modal
            size="l"
            title={t('campaign.objectiveModal.title')}
            primaryButtonProps={{
                label: t('campaign.objectiveModal.primaryButton'),
                style: {
                    width: '100%',
                },
            }}
            isButtonSetFixed
            onConfirm={() => onClick?.(options[selectedIdx].type)}
            hasIcon={false}
            hasSecondaryButton={false}
            onClose={onClose}
        >
            <ObjectiveFormContainer className="objective-content">
                <div className="objective-options">
                    {options.map((objective, idx) => (
                        <ObjectiveCard
                            {...objective}
                            dataTestId={`test-objective-card-${objective.type}`}
                            key={objective.title + idx}
                            onClick={() => setSelectedIdx(idx)}
                            isSelected={selectedIdx === idx}
                        />
                    ))}
                </div>

                <ObjectiveDetails type={options[selectedIdx || 0].type} />
            </ObjectiveFormContainer>
        </Modal>
    )
}

export default ObjectiveForm

const ObjectiveFormContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[400]};
    justify-content: space-between;

    // handle mobile view display
    @media (max-width: 768px) {
        flex-direction: column;
    }

    .objective-options {
        display: flex;
        flex-wrap: wrap;
        gap: ${({ theme }) => theme.spacing[200]};
        max-width: 460px;
        width: fit-content;
        height: fit-content;
    }
`
